export const PROTECTED_ROUTES = [
  "/customer",
  "/reactivate",
  "/routing",
];

export const PRODUCTION_URLS = [
  "https://www.katkin.com",
  "https://katkin.com",
] as const;

export const JWT_HASH_ALGORITHM = "RS256";
